
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search-results",
      function () {
        return require("private-next-pages/search-results.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search-results"])
      });
    }
  